<template>
	<div class="course-hero" :class="'theme-' + course.color_theme">
		<div class="flex-parent-center tw-flex tw-items-center tw-flex-col tw-text-center md:tw-flex-row md:tw-text-left md:tw-items-stretch">
            <div class="tw-relative content-wrapper tw-flex tw-flex-col tw-flex-3 tw-text-white tw-order-1 tw-w-full md:tw-w-3/5 md:tw-order-0 "
			     :class="[{'md:tw-py-10': !extended}, {'tw-text-gray-700': light_colors.includes(course.color_theme)}]">
				<div class="tw-flex tw-flex-col tw-justify-center tw-flex-1" :class="{'tw-pt-14 tw-pb-10': $settings('membership.show_progress') != '1'}">
					<div class="tw-hidden md:tw-block" :style="{height: extended ? '40px' : '15px'}" v-if="$settings('membership.show_progress') == '1'"></div>
					<div class="tw-flex tw-items-center tw-justify-center tw-text-xs tw-uppercase tw-font-semibold md:tw-justify-start md:tw-text-sm">
						<div class="course-spec" v-if="course.module_count > 1">
							<i class="fa fa-layer-group"></i>
							<span>{{ course.module_count }} {{ $t('membership.modules') }}</span>
						</div>
						<div class="course-spec" v-if="course.lesson_count > 0">
							<i class="fa fa-archive"></i>
							<span>{{ course.lesson_count }} {{ $t('membership.lessons') }}</span>
						</div>
						<div class="course-spec" v-if="course.attachments_count > 0">
							<i class="fa fa-paperclip"></i>
							<span>{{ course.attachments_count }} {{ $t('membership.attachments') }}</span>
						</div>
					</div>
					<h1 v-text="course.name"
					    class="tw-leading-snug tw-mb-2 tw-pt-3 md:tw-pt-1"></h1>
					<h2 v-text="course.description" class="tw-leading-loose tw-text-lg tw-mb-8"></h2>
                    <course-hero-cta :course="course" :extended="extended"></course-hero-cta>

					<div style="height: 24px;" v-if="$settings('membership.show_progress') == '1'"></div>
				</div>
				<div class="tab-switcher" v-if="extended">
					<div class="tw-flex tw-uppercase tw-absolute tw-bottom-0 tw-font-bold">
						<div class="hero-menu-item" @click="setMenu('modules')" :class="{'active': menu === 'modules'}">
							<h4 v-text="$t('membership.course_content')"></h4>
						</div>
						<div class="hero-menu-item" @click="setMenu('author')" :class="{'active': menu === 'author'}"
						     v-if="author">
							<h4 v-text="$t('membership.author')"></h4>
						</div>
						<div class="hero-menu-item" @click="setMenu('attachments')"
						     :class="{'active': menu === 'attachments'}"
						     v-if="course.availability.available && course.attachments.length > 0 && hasUnlockedAllContent && isReleasedOrHasDetailsVisible">
							<h4>{{ $t('membership.attachments') }} ({{ attachments_count }})</h4>
						</div>
					</div>
				</div>
			</div>
            <div class="course-preview-big tw-flex tw-flex-col tw-items-center tw-justify-center tw-relative tw-order-0 tw-flex-1 tw-mt-6 tw-mb-3 md:tw-order-1 md:tw-my-0"
				 v-if="$settings('membership.show_progress') == '1'">
                 <div class="tw-relative tw-w-full tw-h-full">
                    <svg width="100%" height="100%" viewBox="0 0 42 42" class="progress-ring-wrapper tw-top-0 tw-left-0 tw-relative md:tw-absolute">
                        <circle class="progress-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent"
                                stroke-width="1.5"></circle>

                        <circle class="progress-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent"
                                stroke-width="1.5" :stroke-dasharray="strokeAnimation" stroke-dashoffset="25"></circle>
                    </svg>
                    <div class="hero-image-wrapper">
                        <div class="hero-image">
                            <img :src="image">
                        </div>
                    </div>
                 </div>
                <div class="tw-hidden md:tw-flex tw-mb-4">
                    <div class="tw-items-center tw-flex tw-mr-2 tw-w-1/2 tw-mr-4" :class="{'tw-w-full': !course.certificate}" v-if="course.trophy && course.trophy.title">
                        <trophy
                                style="width: 50px;"
                                :trophy="course.trophy"
                                :showTitle="false"
                                :showDesc="false"
                                :showTooltip="false"
                                :size="38"
                                :displayOnly="true"
                                orientation="horizontal">
                        </trophy>
                        <p class="tw-ml-2 tw-opacity-75 tw-text-white tw-font-semibold tw-text-left"
                        :class="{'tw-text-gray-600': light_colors.includes(course.color_theme)}">
                            {{ $t('membership.receive') }} {{ course.trophy.title }}
                            {{ $t('membership.on_finish_receive') }}</p>
                    </div>
                    <div v-if="course.certificate && extended" class="tw-flex tw-items-center tw-text-white tw-text-left tw-w-1/2" :class="{'tw-w-full': !course.trophy}">
                        <i class="fas fa-file-certificate tw-text-2xl tw-mr-2"></i>
                        <p class="tw-ml-2 tw-opacity-75 tw-text-white tw-font-semibold tw-text-left" :class="{'tw-text-gray-600': light_colors.includes(course.color_theme)}">{{ $t(`certificates.receive_on_${course.certificate_send_option}`) }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Global from '../../mixins/Global.js'
    import Course from '../../mixins/v2/Course'
	import Link from "../Link.vue";
    import Countdown from "../ui/Countdown.vue";
    import CourseHeroCTA from "./CourseHeroCTA.vue";

export default {
	name: 'CourseHero',

	mixins: [Global, Course],

		components: {
            'course-hero-cta': CourseHeroCTA,
            Link,
            'countdown': Countdown,
		},

        props: [
            'course',
            'modules',
            'author',
            'menu',
            'extended', // extended variant is for the show of courses
            'uploads'],

	data() {
		return {
			envoyer_release_id,
			loaded: false,
			light_colors: ['light_gray', 'light_green'],
		}
	},

	computed: {
		lessons_count() {
			let count = 0;

			for (let i = 0; i < this.modules.length; i += 1) {
				count += this.modules[i].lessons.length;
			}

			return count;
		},

		image() {
			if (this.uploads) {
				if (this.uploads.length > 0) {
					const featured_image = this.uploads.find(upload => upload.type === 'featured-image');

					if (typeof featured_image !== 'undefined') {
						return featured_image.url;
					}
				}

				return '/img/image.resized.jpg';
			}

			return this.course.image;
		},

		toUrl() {
			if (!this.course.availability.available) {
				if (this.extended) {
					if (!this.user && this.course.salespage === '') {
						return '/auth/login#login';
					}

					return this.course.salespage;
				}

				return {
					name: 'courses.show',
					params: {
						course_slug: this.course.slug,
					},
				};
			}

			if (this.course.first_lesson_url === '#' || this.access_to_course_from) {
				return '#';
			}

			const regex = '\/resources\\/(.*\\/)(.*\\/)(.*)';
			const match = this.course.first_lesson_url.match(regex);

			return {
				name: 'lessons.show',
				params: {
					course_slug: match[1].slice(0, -1),
					module_slug: match[2].slice(0, -1),
					lesson_slug: match[3],
				},
			};
		},

		strokeAnimation() {
			return this.loaded ? this.course.progress + ' ' + (100 - this.course.progress) : '0 100';
		},

		attachments_count() {
			if (this.extended) {
				return this.course.attachments.filter(upload => upload.type === 'lesson-files').length;
			}

			return 0;
		},

		hasUnlockedAllContent() {
			return this.modules.filter(module => !module.available).length === 0;
		},
		

        isReleasedOrHasDetailsVisible() {
            return this.$user.isModerator|| this.course.is_released || this.course.details_visible;
        }
	},

	methods: {
		setMenu(name) {
			this.$parent.setMenu(name);
		},
	},

	mounted() {
		setTimeout(() => {
			this.loaded = true;
		}, 0);
	}
}
</script>

<style lang="scss" scoped>
.course-hero {
	.flex-parent-center {
		max-width: 1170px;
		padding-left: 15px;
		padding-right: 15px;
		//min-height: 375px;

		.content-wrapper {
			h1 {
				@apply tw-font-bold tw-text-3xl #{!important};

				@screen md {
					@apply tw-text-5xl #{!important};
				}
			}

			h2 {
				opacity: 0.85;
			}

			.author-preview {
				img {
					width: 38px;
					height: 38px;
				}

				span {
					opacity: 0.85;
				}
			}

			.course-spec {
				@apply tw-px-3;
				opacity: 0.7;

				i {
					@apply tw-pr-1;
				}

				@screen md {
					@apply tw-px-0 tw-pr-4;
				}
			}

			.button {
				display: inline-block;
				padding: 14px;
				border-radius: 100px;
				padding-left: 50px;
				padding-right: 50px;
				font-weight: 600;
				font-size: 14px;
				background: #fff;
				color: #636363;
				box-shadow: 0 6px 15px 0 rgba(36, 37, 38, .08);
				user-select: none;
				transition: all .3s ease;
				text-align: center;

				&:hover {
					box-shadow: 0 6px 15px 5px rgba(36, 37, 38, 0.12);
					transform: translateY(-2px);
				}

				&:active {
					opacity: 0.8;
				}
			}

			.tab-switcher {
				margin-top: 7rem;

				.hero-menu-item {
					@apply tw-mr-3 tw-relative tw-cursor-pointer tw-opacity-75;

					h4 {
						@apply tw-pb-8 tw-px-4;
					}

					&:hover {
						@apply tw-opacity-100;
					}

					&.active {
						@apply tw-opacity-100;

						&:after {
							@apply tw-w-full tw-absolute tw-bottom-0 tw-left-0 tw-rounded-full tw-rounded-b-none;
							content: "";
							height: 5px;
						}
					}
				}
			}

			@screen md {
				margin-right: 2rem;
			}
		}

		.course-preview-big {
			@apply tw-text-center;
			flex-basis: auto;

			.progress-ring-wrapper {
				width: 125px;
				height: 125px;

				.progress-segment {
					transition: 2s;
					stroke: #fff;
				}
			}

                .hero-image-wrapper {
                    position: absolute;
                    border-radius: 100%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: flex-end;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    left: 50%;

				.hero-image {
					width: 80px;
					height: 80px;
					border-radius: 100%;
					overflow: hidden;

					img {
						object-fit: cover;
						min-height: 80px;
					}
				}
			}

			.trophy-wrapper {
				@apply tw-hidden;
				margin-top: -20px;
				width: 275px;

				p {
					top: 7px;
					left: 60px;
				}
			}

                @screen md {
                    .progress-ring-wrapper {
                        width: 325px;
                        height: 325px;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        left: 50%;
                    }

                    .hero-image-wrapper {
                        .hero-image {
                            width: 200px;
                            height: 200px;

                            img {
                                min-height: 200px;
                            }
                        }
				}

				.trophy-wrapper {
					@apply tw-flex;
				}
			}
		}
	}

	@mixin hero-theme($light_color, $color, $dark_color, $extra_light_color) {
		background: linear-gradient(180deg, $light_color, $color);

		.flex-parent-center {
			.finished {
				background: $dark_color;
			}

			.course-preview-big {
				.progress-ring-wrapper {
					.progress-ring {
						stroke: $dark_color;
					}
				}

				.hero-image-wrapper {
					.hero-image {
						border: 4px solid $extra_light_color;
					}
				}
			}

			.content-wrapper {
				.tab-switcher {
					.hero-menu-item {
						&.active {
							&:after {
								background-color: $extra_light_color;
							}
						}
					}
				}
			}
		}
	}

	&.theme-teal {
		@include hero-theme(#2ebda9, #27a291, #1c7d70, #2ec3af);
	}

	&.theme-pink {
		@include hero-theme(#ff4c89, #E91E63, #bf154f, #ff5b93);
	}

	&.theme-orange {
		@include hero-theme(#ffb74c, #FF9800, #da8303, #ffc166);
	}

	&.theme-blue {
		@include hero-theme(#65b9fd, #2196F4, #1a81d4, #57b4ff);
	}

	&.theme-light_blue {
		@include hero-theme(#81D4FA, #4FC3F7, #039BE5, #B3E5FC);
	}

	&.theme-red {
		@include hero-theme(#EF5350, #E53935, #C62828, #E57373);
	}

	&.theme-purple {
		@include hero-theme(#BA68C8, #9C27B0, #7B1FA2, #CE93D8);
	}

	&.theme-deep_purple {
		@include hero-theme(#9575CD, #673AB7, #512DA8, #B39DDB);
	}

	&.theme-indigo {
		@include hero-theme(#7986CB, #3F51B5, #303F9F, #C5CAE9);
	}

	&.theme-cyan {
		@include hero-theme(#00BCD4, #0097A7, #00838F, #4DD0E1);
	}

	&.theme-light_green {
		@include hero-theme(#DCEDC8, #AED581, #689F38, #F1F8E9);
	}

	&.theme-green {
		@include hero-theme(#4CAF50, #388E3C, #7fad4d, #81C784);
	}

	&.theme-light_orange {
		@include hero-theme(#E89A82, #EF7956, #D06748, #E6AA97);
	}

	&.theme-deep_orange {
		@include hero-theme(#FF8A65, #FF5722, #D84315, #FFAB91);
	}

	&.theme-gray {
		@include hero-theme(#616161, #212121, #1d1d1d, #757575);
	}

	&.theme-light_gray {
		@include hero-theme(#e3e4e6, #d3d4d8, #97989c, #eff1f5);
	}

	&.theme-metallic {
		@include hero-theme(#90A4AE, #607D8B, #455A64, #CFD8DC);
	}

	&.theme-brown {
		@include hero-theme(#A1887F, #795548, #5D4037, #D7CCC8);
	}
}
</style>
